<template>
  <TheTable
    :headers="headers"
    :items="props.modelValue"
    v-model="actualPage"
    disable-pagination
    dense
    cell-border
    class="rounded-none border-none">
    <template v-slot:date="{ item }">
      {{ formatDate(item.date) }}
    </template>
    <template v-slot:value="{ item }">
      {{ formatMoneyS(item.value) }}
    </template>
    <template v-slot:liters="{ item }">
      {{ item.liters ? `${item.liters.toString().replace('.', ',')} L` : '' }}
    </template>
    <template v-slot:unity="{ item }">
      {{ formatMoneyS(item.value / item.liters) }}
    </template>
    <template v-slot:mileage="{ item }">
      <span>
        {{ item.mileage ? `${item.mileage.toString().replace('.', ',')} km` : '' }}
        <Error :message="item.error?.mileage?.message" v-if="item.error?.mileage" />
      </span>
    </template>
  </TheTable>
</template>

<script setup>
import { useFormat } from '@/composables/useFormat'
import Error from '../atom/Error.vue'

const { formatDate, formatMoneyS } = useFormat()

const props = defineProps({
  modelValue: Array,
})

const headers = [
  { title: 'Posto', field: 'gasStationName', orderField: 'name', tableOrder: 'gasStation' },
  { title: 'Base', field: 'baseName', orderField: 'name', tableOrder: 'base' },
  { title: 'Data', field: 'date' },
  { title: 'Produto', field: 'gasTypeName', orderField: 'gasType' },
  { title: 'Condutor', field: 'conductorName', orderField: 'name', tableOrder: 'employee' },
  { title: 'Litros', field: 'liters' },
  { title: 'Quilometragem', field: 'mileage' },
  { title: 'Preço Por litro', field: 'unity' },
  { title: 'Valor', field: 'value' },
]
</script>
